import { SmartPillData } from 'owa-smart-pill';
import { SmartPillsAggregatedByFeature } from 'owa-mail-smart-pill-features';

/**
 * Returns a SmartPillsAggregatedByFeature object that contains the number of smart features found in SmartPillData[]
 * @param pills: Flat array of smart pills from mail stamp
 */
export default function aggregateSmartFeaturesFromPills(
    pills: SmartPillData[]
): SmartPillsAggregatedByFeature {
    let aggregatedPills: SmartPillsAggregatedByFeature = {};

    for (let pill of pills) {
        aggregatedPills[pill.featureName] =
            aggregatedPills[pill.featureName] === undefined
                ? 1
                : aggregatedPills[pill.featureName] + 1;
    }

    return aggregatedPills;
}
